/**
 * 划重点默认(描边)粗细
 */
export const DEFAULT_HIGHLIGHT_THICKNESS = 50;
